import React, { Fragment, useEffect, useState } from 'react'
import axios from 'axios'
import {obtenerModular} from '../Services/Rest'
import CrearModular from '../modals/CreaModular';



function InfoModular(props) {
   
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },
      method: 'get',
      url: obtenerModular
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data)
      }).catch((error) => {
        console.log(error)
      })
  }, [setList]);
  return (
    <Fragment>
      <div className="container">
             <div className="text-center">
                <div class="container-fluid">
                  <div class="card shadow mb-4">
                    <div class="card-header py-3">
                      <h6 class="m-0 font-weight-bold text-primary">Información Modular </h6>
                    </div>
                    <div class="card-body">     
                  <CrearModular />
                    <hr className="sidebar-divider" /> 
                      <div class="table-responsive">
                        <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Descripción</th>
                               
                            
                            </tr>
                          </thead>
                          <tbody>
                            {list.map((item) => {
                              return (
                                <tr>
                                  <td>{item.id}</td>
                                  <td>{item.descripcion}</td>
                                  
                                </tr>
                              )
                            })
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </Fragment>
  )
}
export default InfoModular; 